module.exports = __webpack_public_path__ + "static/flags/HR-e428dbd752e7899b672989e4a25bc766.gif";